import Grid from '@mui/material/Grid';

import { SmallText } from '../Typography';

import type SvgIcon from '@mui/material/SvgIcon';
import type { FunctionComponent, PropsWithChildren } from 'react';

type CardIconCaptionProps = PropsWithChildren<{
    readonly color?: string;
    readonly icon: typeof SvgIcon;
    readonly text: string;
}>;

export const CardIconCaption: FunctionComponent<CardIconCaptionProps> = (props) => {
    const { children, color, icon: Icon, text } = props;

    return (
        <Grid
            alignItems="center"
            container={true}
            gap={1}
            sx={{
                '& *': { color: color ?? 'primary.main' },
            }}
        >
            <Icon fontSize="small" />
            <SmallText>{text}</SmallText>
            {children}
        </Grid>
    );
};
